import React, { useEffect } from "react";
import { Navigate, useSearchParams } from "react-router-dom";

// /cart?coupon=WELCOME10 → redirect to checkout carrying the coupon
const CartRedirect = () => {
  const [params] = useSearchParams();
  const coupon = params.get("coupon");
  return <Navigate to={`/checkout${coupon ? `?coupon=${coupon}` : ""}`} replace />;
};

export default CartRedirect;
